import DashboardPage from "pages/Dashboard";

function App() {
  return (
    <div className="App">
      <DashboardPage />
    </div>
  );
}

export default App;
